// extracted by mini-css-extract-plugin
export var lightboxContainer = "Lightbox-module--lightboxContainer--31368";
export var lightboxImage = "Lightbox-module--lightboxImage--bea3d";